import React from "react";

export default function Hero() {
  
  return (

  <>
  <div className="bg-texture"></div>
<div className="hero-section">
    <div className="hero-inner">
 <div className="hero-content">
  <div className="hero-left">
    <div className="left-content">
  <h1>Providing the best Web Developement<br /><span>Solutions</span></h1>
  <p>Unleash the Power of Exceptional Web Experiences.
Elevate Your Brand with Webgurushub's Frontend Wizardry.</p>
  <a className="button" href="#contactus">Get a quote <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
  <div className="developer"></div>
  </div>
  </div>
  <div className="hero-right">
    <div className="hero-img">
      <img src="https://i.ibb.co/CKcN8TF/professional-web-design-social-ink-professional-web-design-png-1000-813-1.png" alt="" />
    </div>
  </div>
 </div>
    </div>
</div>
  </>

  );
}
